import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  BasketItem,
  EnterpriseSearchService,
  ServiceType
} from '@sabstravtech/obtservices/angular';
import {
  TerminalsType,
  type FastTrackEnterpriseSearchInterface
} from '@sabstravtech/obtservices/base';

@Component({
  selector: 'app-basket-fast-track',
  templateUrl: './basket-fast-track.component.html',
  styleUrls: ['./basket-fast-track.component.scss'],
  standalone: false
})
export class BasketFastTrackComponent implements OnInit {
  @Input() fastTrack: BasketItem;
  @Input() duplicateBooking = false;
  @Input() itemIndex = 0;
  @Output() remove: EventEmitter<void> = new EventEmitter<void>();
  @Output() openChangeModal: EventEmitter<void> = new EventEmitter<void>();
  @Input() displayItinerary = false;

  public searchParameters: FastTrackEnterpriseSearchInterface = null;
  travellers = [];

  constructor(private searchService: EnterpriseSearchService) {}

  ngOnInit() {
    this.searchParameters = this.searchService.searches[ServiceType.FastTrack];
    this.travellers = [...(this.fastTrack?.users || []), ...(this.fastTrack?.guests || [])];
  }
}
